module.exports = __webpack_public_path__ + "img/builder-2.29ef40e2.jpg";